import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-[#f8f4ee] relative overflow-hidden">
      <div className="sparkle-container">
        {[...Array(25)].map((_, i) => (
          <span key={i} className="sparkle" />
        ))}
      </div>
    </div>
  );
};

export default Loading;
